import usePrivateAxios from '@/common/api/usePrivateAxios'
import { unFormatCnpj } from '@/common/utils/unFormatters'
import { CreateEstablishmentLeadValidationSchema } from '@/features/establishmentLeadsFunnel/schemas/create.schema'
import { UseMutationResult, useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

export type useCreateEstablishmentLead = (props: {
  onSuccess?: () => void,
  onError?: (error: any) => void,
}) => UseMutationResult<AxiosResponse<any, any>, unknown, CreateEstablishmentLeadValidationSchema>

const useCreateEstablishmentLead: useCreateEstablishmentLead = ({ onSuccess, onError }) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createEstablishmentLead'],
    mutationFn: async (form: CreateEstablishmentLeadValidationSchema) => {
      const lead = {
        display_name: form.display_name,
        general_information_attributes: {
          cnpj: form.general_information?.cnpj ? unFormatCnpj(form.general_information.cnpj) : undefined,
          commercial_kind: form.general_information.commercial_kind.value
        },
        contacts_attributes: [
          {
          ...form.contacts,
          phone_attributes: {
            ...form.contacts.phone
            }
          }
        ],
        observations: form.observations,
      }

      return privateAxios.post('/funnel/establishment/leads', { 
        lead
      })
    },
    onSuccess,
    onError,
  })
}

export default useCreateEstablishmentLead